/* eslint-disable no-unused-vars */
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import actions from '@src/redux/actions';
import { CONTACT_US_URL, VBEE_ZALO_URL } from '@src/configs';
import errorCircleRedIcon from '@src/assets/icons/error-circle-red.svg';
import { ERROR_CODE } from '@src/errors/code';

/**
 * Hook to handle order creation errors, specifically error code 6001
 * Shows a popup when the account cannot purchase the package
 * @returns {Function} handleOrderError - Function to check and handle order errors
 */
const useHandleOrderError = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleOrderError = (orderResponse) => {
    if (!orderResponse || orderResponse.status) {
      return false; // No error or success response
    }

    // Check for error code 6001
    if (orderResponse?.code === ERROR_CODE.BLOCK_PACKAGE_PURCHASE) {
      const supportUrl = CONTACT_US_URL;
      const zaloUrl = VBEE_ZALO_URL;

      const description = t('unableToPurchasePackageDescription', {
        supportUrl,
        zaloUrl,
      });

      dispatch(
        actions.limitedFeaturesDialog.showLimitedFeaturesDialog({
          title: 'unableToPurchasePackage',
          description,
          img: errorCircleRedIcon,
          classNameImg: 'custom-img',
          maxWidth: '512px',
          showOnlyUnderstandButton: true,
        }),
      );

      return true; // Error handled
    }

    return false; // Error not handled by this hook
  };

  return { handleOrderError };
};

export default useHandleOrderError;
